import { useRolloutFlagsVersion } from '@chilipiper/rollout'
import { isMailboxConnectionEnabled } from '@/components/personal-settings/integrations/MailboxIntegration/useMailboxIntegration'

// The email step (CEH-11738) adds one step to every onboarding progress bar while its flag is on.
export const useOnboardingExtraSteps = () => {
  useRolloutFlagsVersion()
  return isMailboxConnectionEnabled() ? 1 : 0
}
